import { isEmpty } from '@ember/utils'
import type { NormalizedInterval } from 'date-fns'
import type { DashboardDrivingTestsDataItem } from 'teacher-ui-client/components/giraffe/charts/dashboard/driving-tests'
import type { SchoolScope, StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export interface DrivingTestsResponse {
  driving_tests_by_grade: {
    grade_level: number
    quiz_completed_percentage: number
  }[]
}

export async function drivingTests(
  this: StudentEventsService,
  product: LegacyProductMs,
  statsScope: SchoolScope | StudentsScope,
  period: NormalizedInterval,
): Promise<Nullable<DashboardDrivingTestsDataItem[]>> {
  if (isEmpty(statsScope.ids)) return null

  const url = this.buildUrl('driving_tests_by_grade', product, statsScope)
  const query = this.buildQuery(statsScope, period)

  const data = await this.fetchData<DrivingTestsResponse>(url, query)
  if (!data) return null

  const { driving_tests_by_grade } = data
  const allPercentagesZero = driving_tests_by_grade.every((grade) => grade.quiz_completed_percentage === 0)

  if (driving_tests_by_grade.length === 0 || allPercentagesZero) return null

  return driving_tests_by_grade
}
